// extracted by mini-css-extract-plugin
export default {"root":"root--TtTYQ","grid":"grid--_Nywj","listItem":"listItem--Ojg80","optionsText":"optionsText--SN_Ge","box":"box--AE30h","boxItems":"boxItems--VeeLW"};